<template>
  <div class="pokemon-move is-block">
    <div class="columns is-variable is-12 is-gapless" v-if="MovesList && MovesMethods && MovesTargets">
      <div class="column is-1" v-if="MovesMethods[data[moveKeyMap['method_id']]]['identifier'] === 'level-up'">
        <p class="is-size-7">LVL</p>
        {{data[moveKeyMap['level']]}}
        <!-- <p class="is-size-7">LVL:{{data[moveKeyMap['level']]}}</p> -->
      </div>
      <div class="column is-1" v-if="MovesMethods[data[moveKeyMap['method_id']]]['identifier'] === 'machine'">
        <p class="is-size-7">TM</p>
        {{data[moveKeyMap['tm']]}}
      </div>
      <div class="column is-3">
        <p class="title is-size-5">{{MovesList[data[moveKeyMap['move_id']]]['name']}}</p>
        {{MovesList[data[moveKeyMap['move_id']]]['damage_class']}}
      </div>
      <div class="column is-1">
        <p class="is-size-7">POWER</p>
        {{MovesList[data[moveKeyMap['move_id']]]['power']}}
      </div>
      <div class="column is-1">
        <p class="is-size-7">PP</p>
        {{MovesList[data[moveKeyMap['move_id']]]['pp']}}
      </div>
      <div class="column is-1">
        <p class="is-size-7">ACC.</p>
        <p v-if="MovesList[data[moveKeyMap['move_id']]]['accuracy']">
          {{MovesList[data[moveKeyMap['move_id']]]['accuracy']}}%
        </p>
      </div>
      <div class="column is-3">
        <p class="is-size-7">TARGET</p>
        <p class="is-size-6">{{MovesTargets[MovesList[data[moveKeyMap['move_id']]]['target_id']].name}}</p>
      </div>
      <div class="column is-1">
        <pokemon-type :id="String(MovesList[data[moveKeyMap['move_id']]]['type_id'])"></pokemon-type>
      </div>
    </div>
  </div>
</template>


<script>
import {mapGetters, mapActions} from 'vuex'
import PokemonType from './PokemonType'

export default {
  name: 'pokemonMove',
  components: {
    PokemonType,
  },
  props: {
    'data': Array,
    'moveKeyMap': Object,
  },
  data() {
    return {
      moveData: null,
    }
  },
  computed: {
    ...mapGetters({
      MovesList: 'moves/list',
      MovesMethods: 'moves/methods',
      MovesEffects: 'moves/effects',
      MovesTargets: 'moves/targets',
      MovesDamageClasses: 'moves/damageClasses',
      // PokemonTypes: 'pokemon/types',
    })
  },
  methods: {
    goPokemonList(type) {
      this['pokemon/listPageSetFilter']({key: 'type', value: type})
      this.$router.push('/pokemon/list')
    },
    ...mapActions([
      'pokemon/listPageSetFilter',
    ])
  }
}
</script>

<style lang="scss">
@import "~@/assets/css/variables.scss";

.pokemon-move {
  .columns {
    border-bottom: 1px solid $grey;
    padding: 5px 0;
    margin-bottom: 5px;
  }
  .details div {
    margin:0 5px 0 0;
  }
  .pokemon-type {
    margin-top: 11px;
  }
}
</style>
